export default __webpack_public_path__ + "static/media/ChartTreeMap.fb6f9eb5.svg";